function simPRORouter(options) {
  this.setValues = function (options) {
    this.provider = options.provider ? options.provider : 'none';
    this.key = options.key;
    this.timezone = options.timezone ? options.timezone : '';
  };

  this.getDistanceMatrix = function (origins, destinations, callback) {
    let key = this.key;
    let provider = this.provider;
    let url = '';

    let adressesStr = destinations.geometry.location.lng + "," + destinations.geometry.location.lat;

    origins.forEach(function (origin) {
      adressesStr += ";" + origin.geometry.location.lng + "," + origin.geometry.location.lat
    });

    if (provider === 'locationiq') {
      url = 'https://' + getLocationIQServerLocale(this.timezone) + '.locationiq.com/v1/matrix/driving/' + adressesStr + "?destinations=0" +
        "&annotations=distance,duration&key=" + key;
    } else {
      // probably not supported
      url = 'https://router.project-osrm.org/table/v1/driving/' + adressesStr + "?destinations=0" +
        "&annotations=distance,duration";
    }

    $.ajax({
      url: url,
      dataType: 'json',
      tryCount: 0,
      retryLimit: 3,
      success: function (response) {
        for (let i = 0; i < origins.length; i++) {
          origins[i].distance = response.distances[i + 1];
          origins[i].duration = response.durations[i + 1];
        }
        origins.push(destinations);

        callback(origins, 'OK');
        return;
      },
      error: function (xhr, textStatus, errorThrown) {
        if (xhr.status === 401) {
          this.tryCount++;
          if (this.tryCount <= this.retryLimit) {
            // retry is instantaneous, which doesnt really matter since requests where throttled from start
            // however there are still better ways to to do this.
            $.ajax(this);

            return;
          }
        }
        callback(xhr.responseJSON, 'ERROR');
      }
    });
  };

  this.setValues(options);
}
